// extracted by mini-css-extract-plugin
module.exports = {"headerHeight":"80px","Wrapper":"nft-list_Wrapper__E6LF5","ErrorWrapper":"nft-list_ErrorWrapper__DJAT_","ErrorIcon":"nft-list_ErrorIcon__tSKqP"};